import React, { useState } from "react"
import { Card, Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { parsedUser } from "../../../common/GetCurrentUser"
import FlagsModal from "../../Record/FlagsModal"
import { resolvePhotoSrc, PHOTO_FALLBACK } from "../../../common/photoSource"

const VerificarAntecedentesCardView = (props: { records: any[]; isLoading?: boolean; backgroundCheck?: boolean }) => {
  const records = props.records
  const { t } = useTranslation("global")
  const user = parsedUser()
  const [showFlags, setShowFlags] = useState(false)
  const [selectedCedula, setSelectedCedula] = useState("")
  return (
    <>
    <Row>
      {records &&
        records.map((item: any, index: number) => {
          const hasFichas = (item.fichas ?? 0) > 0
          const hasAudiencias = (item.audiencias?.total ?? 0) > 0
          const hasSentencias = (item.sentencias?.total ?? 0) > 0
          const hasJudicialSignals = !!item.fichado || hasFichas || hasAudiencias || hasSentencias

          return (
            <Col xs={12} md={4} lg={4} key={index}>
              <Card className="mb-4">
                <Card.Body className="p-0  text-center">
                  {resolvePhotoSrc(item) && (
                    <img
                      alt=""
                      className="card-img-top"
                      style={{ height: "200px", width: "200px", objectFit: "cover", objectPosition: "center" }}
                      id="image"
                      src={resolvePhotoSrc(item) ?? PHOTO_FALLBACK}
                      onError={(e: any) => {
                        if (e.target.src !== PHOTO_FALLBACK) {
                          e.target.src = PHOTO_FALLBACK
                        }
                      }}
                    />
                  )}
                  <p className="text-center my-2 card-text text-uppercase">
                    {`${item.nombres} ${item.apellido1} ${item.apellido2}`}
                    <br />
                    <b>{item.cedula}</b>
                    <p>
                      {item.extraditado && (
                        <>
                          <span
                            className="badge "
                            style={{ backgroundColor: "blue" }}
                            title={
                              "Solicitar certificado de no extradicción"
                            }
                          >
                            <i className="fa fa-exclamation-triangle me-2"></i>
                            Solicitar certificado de no extradicción
                          </span>
                          <br />
                        </>
                      )}
                      {!hasJudicialSignals && (
                        <div
                          className="badge bg-success text-wrap"
                          title={"No antencedentes judiciales"}
                        >
                          <i className="fa fa-check"></i>
                          <span className="ms-2">No antencedentes judiciales</span>
                        </div>
                      )}
                      {(hasFichas || hasSentencias) && (
                        <div
                          className="badge bg-danger  text-wrap"
                          title={
                            "Solicitar certificado de no antecedentes judiciales"
                          }
                        >
                          <i className="fa fa-exclamation-triangle"></i>
                          <span className="ms-2">
                            Solicitar certificado de no antencedentes judiciales
                          </span>
                        </div>
                      )}
                      {item.desaparecido && (
                        <>
                          <div
                            className="badge bg-warning  text-wrap"
                            title={
                              "Desaparecid@"
                            }
                          >
                            <i className="fa fa-exclamation-triangle"></i>
                            <span className="ms-2">
                              Desaparecid@
                            </span>
                          </div>
                          <br />
                        </>
                      )}
                      {item.deportado && item.deportado === true && (<><br />
                        <span
                          className="badge "
                          style={{ backgroundColor: "purple" }}
                          title={
                            "Deportado"
                          }
                        >
                          <i className="fa fa-exclamation-triangle me-2"></i>
                          Solicitar Certificado de no Deportación
                        </span>
                      </>
                      )}
                      <br />
                      <div
                        className="badge bg-warning  text-wrap"
                        title={"No casos laborales"}
                      >
                        <i className="fa fa-check"></i>
                        <span className="ms-2">No casos laborales</span>
                      </div>
                      {item.banderas?.pip && <>
                        <br />
                        <span className="badge bg-danger text-white" title="Persona Imputada Penalmente">PIP</span>
                      </>}
                      {item.banderas?.padep && <>
                        <br />
                        <span className="badge bg-danger text-white" title="Persona Asociada a un Delito Precedente">PADEP</span>
                      </>}
                      {item.banderas?.pecop && <>
                        <br />
                        <span className="badge bg-dark text-white" title="Condenado PECOP">PECOP</span>
                      </>}
                      {item.banderas?.rasadep && <>
                        <br />
                        <span className="badge bg-danger text-white" title="Razón Social Asociada a un Delito Precedente">RASADEP</span>
                      </>}
                      {item.banderas?.pep && <>
                        <br />
                        <span className="badge bg-warning text-dark" title="Persona Expuesta Públicamente">PEP</span>
                      </>}
                    </p>
                  </p>
                </Card.Body>
                <Card.Footer className="text-center ">
                  <div className="mb-2">
                    {hasAudiencias && (
                      <span className="btn btn-warning btn-sm text-white me-2">
                        <i className="fa fa-gavel me-2"></i>
                        {t("Procesos")}
                      </span>
                    )}
                    {hasSentencias && (
                      <span className="btn btn-info btn-sm text-white me-2">
                        <i className="fa fa-scale-balanced me-2"></i>
                        {t("Sentencias")}
                      </span>
                    )}
                    {user && user.RoleId === "admin" && (
                      <button
                        className="btn btn-primary btn-sm me-2"
                        onClick={() => {
                          setSelectedCedula(item.cedula || "")
                          setShowFlags(true)
                        }}
                      >
                        <i className="fa fa-flag"></i>
                      </button>
                    )}
                  </div>

                  <button className="btn btn-primary mt-2"
                    onClick={() => {
                      window.open(
                        `bcr/${item.cedula}`,
                        "_blank"
                      )
                    }}
                  >
                    <i className="fa fa-file"></i> {t("Ver Reporte")}
                  </button>


                </Card.Footer>
              </Card>
            </Col>
          )
        })}
    </Row>
    {showFlags && (
      <FlagsModal
        show={showFlags}
        identificador={selectedCedula}
        onClose={() => setShowFlags(false)}
      />
    )}
    </>
  )
}

export default VerificarAntecedentesCardView
